import { AdditionalOptionsMenu, AdditionalOptionsMenuProps } from '../../components/AdditionalOptionsMenu';
import { useChatDrawerButtonUtils } from '../chat/useChatDrawerButtonUtils';

export function ProviderAdditionalOptionsMenuWrapper({ children }: Pick<AdditionalOptionsMenuProps, 'children'>) {
  const shouldShowVisualIndicator = useChatDrawerButtonUtils().unreadMessageCount > 0;
  return (
    <AdditionalOptionsMenu shouldShowVisualIndicator={shouldShowVisualIndicator}>{children}</AdditionalOptionsMenu>
  );
}
